import styled from 'styled-components';

export const SliderWrapper = styled.div`
  overflow: hidden;
  width: 340px;
  position: relative;
`;
export const SliderHolder = styled.div`
  transition: ease 1000ms;
  display: flex;
`;
export const SlideItem = styled.div`
  width: ${p => (p.width ? p.width : '340px')};
  flex-shrink: 0;
  text-align: center;
  img {
    width: 216px;
    object-fit: cover;
  }
`;
export const SlideDots = styled.div`
  text-align: center;
  margin-top: 60px;
  .slideshowDot {
    background: #2f488a;
    opacity: 0.2;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    display: inline-block;
    margin-right: 4px;
    cursor: pointer;
    transition: all 0.3s linear;
  }
  .slideshowDot.active {
    opacity: 1;
  }
`;
